module.exports = __webpack_public_path__ + "static/media/icon_more_view_arrow.c286285c.svg";